var $92978e0c4ecafa32$exports = {};
$92978e0c4ecafa32$exports = {
  "decrease": function decrease(args) {
    return "".concat(args.fieldLabel, " verringern");
  },
  "increase": function increase(args) {
    return "".concat(args.fieldLabel, " erh\xF6hen");
  },
  "numberField": "Nummernfeld"
};
export { $92978e0c4ecafa32$exports as default };